import * as Sentry from '@sentry/react'
import { Paper, Stack, Text, Button } from '@mantine/core'

type Props = {
  feature: string
  children: React.ReactNode
}

function PageErrorFallback({ onReset }: { onReset: () => void }) {
  return (
    <div className="flex h-full items-center justify-center p-8">
      <Paper p="lg" withBorder>
        <Stack align="center" gap="md">
          <Text fw={600} size="lg">
            This section encountered an error
          </Text>
          <Text size="sm" c="dimmed">
            Something went wrong loading this page. Our team has been notified.
          </Text>
          <Button onClick={onReset}>Try Again</Button>
        </Stack>
      </Paper>
    </div>
  )
}

export function PageErrorBoundary({ feature, children }: Props) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => <PageErrorFallback onReset={resetError} />}
      beforeCapture={(scope) => {
        scope.setTag('feature', feature)
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  )
}
